import { t as createLogger } from "./app.shared-CmP4XLF_.js";

var log = createLogger("cart-item");

var cart_item_default = (() => {
    if (customElements.get("cart-item")) return;
    customElements.define("cart-item", class CartItem extends HTMLElement {
        constructor() {
            super();
            this._onClick = this._onClick.bind(this);
            this._onSelectChange = this._onSelectChange.bind(this);
            this._onCartUpdated = this._onCartUpdated.bind(this);
        }
        connectedCallback() {
            this.addEventListener("click", this._onClick);
            this.addEventListener("select:change", this._onSelectChange);
            document.addEventListener("cart:updated", this._onCartUpdated);
        }
        disconnectedCallback() {
            this.removeEventListener("click", this._onClick);
            this.removeEventListener("select:change", this._onSelectChange);
            document.removeEventListener("cart:updated", this._onCartUpdated);
        }
        _onClick(event) {
            const button = event.target.closest("button");
            if (!button) return;
            const line = Number(this.dataset.line);
            const quantity = Number(this.dataset.quantity);
            if (!line) return;
            if (button.hasAttribute("data-minus")) {
                if (quantity <= 1) return;
                this._mutate({
                    line: line,
                    quantity: quantity - 1
                });
            } else if (button.hasAttribute("data-plus")) {
                const max = Number(this.dataset.quantityMax);
                if (max && quantity >= max) return;
                this._mutate({
                    line: line,
                    quantity: quantity + 1
                });
            } else if (button.hasAttribute("data-remove")) this._mutate({
                line: line,
                quantity: 0
            });
        }
        async _mutate(data) {
            if (!window.MBF?.cart) return;
            try {
                await window.MBF.cart.change(data);
            } catch (error) {
                log("errors", "cart change failed", {
                    error: error,
                    line: data.line,
                    quantity: data.quantity
                });
                if (error?.duplicate) return;
                document.dispatchEvent(new CustomEvent("cart-item:error"));
            }
        }
        _onSelectChange(event) {
            if (event.target.dataset.name !== "size") return;
            const {value: value} = event.detail;
            if (value === this.dataset.variantId) return;
            this._swapVariant(Number(this.dataset.line), Number(value));
        }
        async _swapVariant(line, pendingVariant) {
            if (!pendingVariant || !window.MBF?.cart) return;
            const quantity = Number(this.dataset.quantity);
            document.dispatchEvent(new CustomEvent("cart:save-start"));
            try {
                await window.MBF.cart.change({
                    line: line,
                    quantity: 0
                });
                const cart = await window.MBF.cart.add({
                    items: [ {
                        id: pendingVariant,
                        quantity: quantity
                    } ]
                });
                document.dispatchEvent(new CustomEvent("cart:save-end", {
                    detail: {
                        cart: cart
                    }
                }));
            } catch (error) {
                log("errors", "variant swap failed", {
                    line: line,
                    quantity: quantity,
                    pendingVariant: pendingVariant,
                    name: error?.name,
                    message: error?.message,
                    status: error?.status,
                    description: error?.description,
                    errors: error?.errors,
                    duplicate: Boolean(error?.duplicate)
                });
                this.querySelector('custom-select[data-name="size"]')?.setSelected(this.dataset.variantId);
                document.dispatchEvent(new CustomEvent("cart-item:error"));
                document.dispatchEvent(new CustomEvent("toast:show", {
                    detail: {
                        message: window.MBF?.strings?.cart?.errors?.size || ""
                    }
                }));
            }
        }
        _onCartUpdated(event) {
            const cart = event.detail?.cart;
            if (!cart) return;
            const item = (cart.items || [])[Number(this.dataset.line) - 1];
            if (!item || String(item.variant_id) !== this.dataset.variantId) return;
            this.dataset.quantity = item.quantity;
            const qtyEl = this.querySelector("[data-quantity-value]");
            if (qtyEl) qtyEl.textContent = item.quantity;
            const minus = this.querySelector("[data-minus]");
            if (minus) minus.disabled = item.quantity <= 1;
            const plus = this.querySelector("[data-plus]");
            if (plus) {
                const max = Number(this.dataset.quantityMax);
                plus.disabled = Boolean(max) && item.quantity >= max;
            }
        }
    });
})();